import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';

function SearchArea(props: any) {
  let myProps = {
    get_comp_arr_by_ajax: (inData: any) => { },
    listOpt: {},
    list: (inOptObj: any) => { },
    from_to_data: {},
    set_from_to_data: (inData: any) => { },
    send_to_other: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let from_to_data = myProps.from_to_data;

  let is_manage_comp = false;
  if (user.comp_seq == "4") {
    is_manage_comp = true;
  }

  const [comp_group_arr, set_comp_group_arr] = useState<any>([]);
  const [comp_arr, set_comp_arr] = useState<any>([]);
  const [to_comp_arr, set_to_comp_arr] = useState<any>([]);

  useEffect(() => {
    get_comp_group_by_ajax();
  }, [user.comp_seq]);

  const get_comp_group_by_ajax = () => {
    let form_json_data: any = {
      order_id: "a_name",
      is_paging: "",
    };

    if (user.comp_seq != "4") {
      get_group_link_by_ajax();
      set_comp_group_arr([]);
      myProps.set_from_to_data({
        ...from_to_data,
        to_comp_seq:user.comp_seq
      });
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/group/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] == "true") {
          set_comp_group_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_group_link_by_ajax = () => {
    let form_json_data: any = {
      s_mcomp_seq: user.comp_seq,
      order_id: "a_mcomp_name",
      is_paging: "",
    };
    if (strFunc.is_empty(form_json_data.s_mcomp_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/group_link/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] == "true") {
          let tmp_group_seq_arr = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let row_link_info = response.data["data"]["info_arr"][i];
            if (row_link_info["a_mcomp_seq"] && strFunc.str_in_array(row_link_info["a_mcomp_seq"], tmp_group_seq_arr) == -1) {
              tmp_group_seq_arr.push(row_link_info["a_group_seq"]);
            }
          }
          if (tmp_group_seq_arr.length > 0) {
            get_comp_arr_by_ajax({ s_mcomp_group_seq: tmp_group_seq_arr });
          }
        } else {

        }
      });
  };

  const get_comp_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      s_mcomp_group_seq: "",
      ...inData
    };
    if (strFunc.is_empty(opt_obj.s_mcomp_group_seq)) {
      set_comp_arr([]);
      myProps.set_from_to_data({
        ...from_to_data,
        from_group_seq: opt_obj.s_mcomp_group_seq,
      });
      return false;
    }
    let form_json_data: any = {
      s_mcomp_group_seq: opt_obj.s_mcomp_group_seq,
      order_id: "a_name",
      s_is_use: "1",
      s_sort: "comp",
      is_paging: "",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] == "true") {
          set_comp_arr(response.data["data"]["info_arr"]);
          if (response.data["data"]["info_arr"].length > 0) {
            myProps.set_from_to_data({
              ...from_to_data,
              from_group_seq: opt_obj.s_mcomp_group_seq,
              from_comp_seq: response.data["data"]["info_arr"][0]["a_seq"]
            });
            myProps.list({
              s_mcomp_seq: response.data["data"]["info_arr"][0]["a_seq"],
              api_key: response.data["data"]["info_arr"][0].a_api_key,
              api_user_seq: "9999",
            });
          }
        } else {

        }
      });
  };

  const get_to_comp_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      s_mcomp_group_seq: "",
      ...inData
    };
    if (strFunc.is_empty(opt_obj.s_mcomp_group_seq)) {
      set_to_comp_arr([]);
      return false;
    }

    let form_json_data: any = {
      s_mcomp_group_seq: opt_obj.s_mcomp_group_seq,
      order_id: "a_name",
      s_is_use: "1",
      s_sort: "comp",
      is_paging: "",
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] == "true") {
          set_to_comp_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  return (
    <div className="my_flex_center">
      {is_manage_comp &&
        <select className="search-input" name="from_group_seq" value={from_to_data.from_group_seq}
          onChange={(e: any) => {
            get_comp_arr_by_ajax({ s_mcomp_group_seq: e.target.value });
          }}
        >
          <option value="">전체</option>
          {
            comp_group_arr.map((item: any, index: number) => {
              return (
                <option key={index} value={item.a_seq}>{item.a_name}</option>
              );
            })
          }
        </select>
      }
      <select className="search-input" name="from_comp_seq" value={from_to_data.from_comp_seq}
        onChange={(e: any) => {
          myProps.set_from_to_data({
            ...from_to_data,
            from_comp_seq: e.target.value
          });
          let tmp_select_comp_info: any = null;
          for (let i = 0; i < comp_arr.length; i++) {
            if (comp_arr[i].a_seq == e.target.value) {
              tmp_select_comp_info = comp_arr[i];
              break;
            }
          }
          let tmp_search_list_opt: any = {
            now_page: 1,
            s_mcomp_seq: e.target.value,
          };
          if (tmp_select_comp_info) {
            tmp_search_list_opt.api_key = tmp_select_comp_info.a_api_key;
            tmp_search_list_opt.api_user_seq = "9999";
          }
          myProps.list(tmp_search_list_opt);
        }}>
        <option value="">전체</option>
        {
          comp_arr.map((item: any, index: number) => {
            return (
              <option key={index} value={item.a_seq}>{item.a_name}</option>
            );
          })
        }
      </select>
      {
        is_manage_comp == false &&
        <button className='btn btn-dark' onClick={()=>{myProps.send_to_other({});}} >가져오기</button>
      }
      {is_manage_comp &&
        <span>
          보내기:
          <select className="search-input ml-1" name="to_group_seq" value={from_to_data.to_group_seq}
            onChange={(e: any) => {
              myProps.set_from_to_data({
                ...from_to_data,
                to_group_seq: e.target.value,
                to_comp_seq: ""
              });
              get_to_comp_arr_by_ajax({
                s_mcomp_group_seq: e.target.value
              });
            }}
          >
            <option value="">전체</option>
            {
              comp_group_arr.map((item: any, index: number) => {
                return (
                  <option key={index} value={item.a_seq}>{item.a_name}</option>
                );
              })
            }
          </select>
          <select className="search-input" name="to_comp_seq" value={from_to_data.to_comp_seq}
            onChange={(e: any) => {
              myProps.set_from_to_data({
                ...from_to_data,
                to_comp_seq: e.target.value
              });
            }}>
            <option value="">전체</option>
            {
              to_comp_arr.map((item: any, index: number) => {
                return (
                  <option key={index} value={item.a_seq}>{item.a_name}</option>
                );
              })
            }
          </select>
          <button className='btn btn-dark ml-1' onClick={()=>{myProps.send_to_other({});}} >보내기</button>
        </span>
      }
    </div>
  );
};
export default SearchArea;